module.exports = __webpack_public_path__ + "static/media/Test29.46bf60e8.bmp";